module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-chart"
  }, [_c('div', {
    staticClass: "headline"
  }, [_c('h2', {
    staticClass: "col s12 m6"
  }, [_vm._v("Historia kalkulacji")]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeSet),
      expression: "activeSet"
    }],
    staticClass: "stats-active-set browser-default",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeSet = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.statSets), function(item, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v("\n          " + _vm._s(item.name) + "\n        ")])
  }), 0)])]), _vm._v(" "), _c('vue-chart', {
    staticClass: "col s12",
    attrs: {
      "chartType": _vm.chartType,
      "columns": _vm.columns,
      "rows": _vm.rows,
      "options": _vm.options,
      "language": "pl"
    }
  }), _vm._v(" "), _c('Loader', {
    attrs: {
      "loading": _vm.getPendingHistory
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dbf1c40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/statsChart.vue
// module id = 393
// module chunks = 0